class VariantButtons extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectId = this.getAttribute('select-id');
    this.select = document.getElementById(this.selectId);

    if (!this.select) {
      console.error(`Select element with id "${this.selectId}" not found`);
      return;
    }

    this.buttonTemplate = this.innerHTML.trim();
    this.innerHTML = '';

    this.select.style.display = 'none';
    this.render();
    this.setupMutationObserver();
  }

  render() {
    this.innerHTML = '';

    Array.from(this.select.options).forEach((option, index) => {
      if (!option.disabled) {
        const button = this.createButton(option.textContent);
        button.classList.remove('hidden');
        button.addEventListener('click', () => {
          if (this.select.selectedIndex !== index) {
            this.select.selectedIndex = index;
            this.triggerChangeEvent();
          }
          this.updateSelectedButton();
        });
        this.appendChild(button);
      }
    });

    this.updateSelectedButton();
    this.select.addEventListener('change', () => this.updateSelectedButton());
  }

  createButton(name) {
    const template = document.createElement('template');
    template.innerHTML = this.buttonTemplate.replace('[NAME]', name);
    return template.content.firstElementChild.cloneNode(true);
  }

  updateSelectedButton() {
    const buttons = this.querySelectorAll('button');
    buttons.forEach(button => button.classList.remove('selected'));
    
    let selectedIndex = 0;
    Array.from(this.select.options).forEach((option, index) => {
      if (!option.disabled) {
        buttons[selectedIndex].dataset.active = false;

        if (index === this.select.selectedIndex) {
          buttons[selectedIndex].dataset.active = true;
        }
        selectedIndex++;
      }
    });
  }

  triggerChangeEvent() {
    const changeEvent = new Event('change', { bubbles: true });
    const inputEvent = new Event('input', { bubbles: true });
    
    this.select.dispatchEvent(changeEvent);
    this.select.dispatchEvent(inputEvent);
  }

  setupMutationObserver() {
    const config = { attributes: true, childList: true, subtree: true };
    
    const callback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' || 
            (mutation.type === 'attributes' && mutation.attributeName === 'disabled')) {
          this.render();
          break;
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(this.select, config);
  }
}

customElements.define('variant-buttons', VariantButtons);